const config = {
  firebase: {
    config: {
      apiKey: 'AIzaSyD1jT3jfTzOwU0Nvh22INTgOAaqgZpjH0g',
      authDomain: 'fds-dev-ff2ac.firebaseapp.com',
      databaseURL: 'https://fds-dev-ff2ac.firebaseio.com',
      projectId: 'fds-dev-ff2ac',
      storageBucket: 'fds-dev-ff2ac.appspot.com',
      messagingSenderId: '955805347603',
      appId: '1:955805347603:web:060c79aa2146f60201b4e6',
    },
    messaging: {
      publicKey: 'BChVLe0Tb5OfiOdouxit05eZCu7TlR9KBO8kLTlaB97H7jkKuspLq6uUQksopwVsYSI1Y2ttMLrstMbDP2jC9_c',
    },
    status: false,
  },
  api: {
    // url: 'https://apiv2.airpresense.tech',
    url: 'https://dev-apigateway.airpresense.tech',
    url_auth: 'https://dev-apigateway.airpresense.tech',
    url_socket: 'https://dev-notification.airpresense.tech',
    version: 'v3/api',
    // token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJzeXN0ZW0iLCJpYXQiOjE1OTg5NTExNzUsImV4cCI6MTkxNDMxMTE3NX0.NRLNlB5cwxMUm65lmqKzET6qWQZvfwhZy4uKYERkU8E',
  },
  protocol: 'https',
  vconsole: {
    enabled: true,
  },
  style: {
    useHN: false,
  },
  mapHiding: [],
  groupNotification: true,
  cache: true,
  configType: true,
  battery: {
    hideBatteryAfter: 1440,
  },
  displayPlaceForEmergency: true,
  features: {
    report: {
      vitalSign: true,
      garmin: true,
    },
    dashboard: {
      roomName: true,
    },
    allPatients: {
      syncNirun: true,
    },
  },
  headerView: {
    default: 'Pre-Sense System',
  },
  auth: {
    authMode: 'cognito', //cognito,local
  },
};
module.exports = config;
